import { render, staticRenderFns } from "./OccupancyByRoomBanner.vue?vue&type=template&id=00362270&scoped=true"
import script from "./OccupancyByRoomBanner.vue?vue&type=script&lang=js"
export * from "./OccupancyByRoomBanner.vue?vue&type=script&lang=js"
import style0 from "./OccupancyByRoomBanner.vue?vue&type=style&index=0&id=00362270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00362270",
  null
  
)

export default component.exports